import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type AiAgentAvatarState = 'idle' | 'thinking' | 'processing' | 'executing';
export type AiAgentAvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type AiAgentAvatarVariant = 'default' | 'fab' | 'watermark';

@Component({
  selector: 'app-ai-agent-avatar',
  templateUrl: './ai-agent-avatar.component.html',
  styleUrls: ['./ai-agent-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AiAgentAvatarComponent {
  private static nextGradientId = 0;

  private readonly gradientId = AiAgentAvatarComponent.nextGradientId++;
  readonly primaryGradientId = `ai-agent-avatar-primary-gradient-${this.gradientId}`;
  readonly secondaryGradientId = `ai-agent-avatar-secondary-gradient-${this.gradientId}`;
  readonly sparkGradientId = `ai-agent-avatar-spark-gradient-${this.gradientId}`;

  @Input() state: AiAgentAvatarState = 'idle';
  @Input() size: AiAgentAvatarSize = 'md';
  @Input() variant: AiAgentAvatarVariant = 'default';

  getGradientUrl(gradientId: string): string {
    return `url(#${gradientId})`;
  }
}
